const divFormTitle = {
  typographyTrue: 'Registration of New Equipment',
  typographyFalse: 'Edit Equipment Info',
  typographyFinancialInfo: 'Edit Equipment Financial Info',
};

export default divFormTitle;
